'use strict'

module.exports = require('@rill/http')
